import JSONEditor from '@monaco-editor/react';
import type { FC } from 'react';

interface JsonEditorFieldProps {
  value?: string | object;
  onChange?: (value: object) => void;
  isMagicRole?: boolean;
  height?: number | string;
}

export const JsonEditorField: FC<JsonEditorFieldProps> = ({ value, onChange, isMagicRole, height = 400 }) => {
  const stringValue = typeof value === 'object' && value !== null ? JSON.stringify(value, null, 2) : '';

  return (
    <JSONEditor
      defaultLanguage="json"
      height={height}
      options={{
        minimap: { enabled: false },
        readOnly: !isMagicRole,
      }}
      value={stringValue}
      onChange={newValue => {
        const parsedValue = newValue ? JSON.parse(newValue) : {};
        onChange?.(parsedValue);
      }}
    />
  );
};
